import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { DataLayerCardBanner } from '@com-delta-idp/mnx-fast-action-banner';
import { AnalyticsService } from '@com-delta-idp/mnx-utils';
import { Banner, Earns } from './models/earns.interfaces';

@Component({
  selector: 'idp-earns',
  templateUrl: './earns.component.html',
  styleUrls: ['./earns.component.scss']
})
export class EarnsComponent implements OnChanges {
  @Input() content: Earns = {} as Earns;
  @Output() openLink = new EventEmitter<string>();

  displaySecondaryHeader = true;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'].currentValue.banner.loaded) {
      this.updateDataLayer(changes['content'].currentValue.banner);
    }
  }

  /** Update the data layer with default values because is not a dynamic banner  */
  updateDataLayer(offerData: Banner) {
    const path = 'idp.dataLayer.digitalData.attributes';
    const bannerData: DataLayerCardBanner = {
      applicationStatus: offerData.offer ? 'notApproved' : '',
      cardType: offerData.offer ? (offerData.offer.cardType as string) : '',
      offerId: offerData.offer ? 'default' : ''
    };
    this.analyticsService.updateDataLayer('cardBanner', bannerData, path);
  }

  redirect(link: string) {
    this.openLink.emit(link);
  }
}
